import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `PUT …/workflow-runs/{run}/handling` carries no body: the target is entirely in the URL. */
class MarkWorkflowRunHandled {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
	) {
		Object.freeze(this);
	}
}

export default MarkWorkflowRunHandled;
